import React, { useEffect, useState } from 'react'
import Get from '../services/Get';
import { Button, Col, Layout, message, Result, Row, Spin, Typography } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import LandingHeader from '../components/layout/Header';
import LandingFooter from '../components/layout/Footer';

const Page = () => {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState();
  const [isError, setIsError] = useState(false);

  const { pathname } = useLocation();
  const navigate = useNavigate();
  const page = pathname.replace("/", "");

  const getContent = () => {
    setLoading(true);
    Get.getPageContent(page).then((res) => {
      console.log(res);
      if (res.data && res.data.length > 0) {
        setContent(res.data[0]);
      } else {
        setIsError(true);
      }
    }).catch((err) => {
      message.error(err);
    }).finally(() => {
      setLoading(false);
    })
  }

  useEffect(() => {
    getContent();
  }, []);

  return (
    <div>
      <Layout>
        <LandingHeader />
        <Row justify={'center'} style={{ minHeight: '80vh' }}>
          {isError ? (
            <Result
              status="404"
              title="404"
              subTitle="Sorry, the page you visited does not exist."
              extra={<Button type="primary" className='form-btn' onClick={() => navigate('/')}>Back Home</Button>}
            />
          ) : (
            <Col xs={24} md={14} style={{ padding: 40 }}>
              {
                loading ? (
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh' }}>
                    <Spin size="large" />
                  </div>
                ) : (
                  <>
                    <Typography.Title className='mb-25'>
                      {content.title}
                    </Typography.Title>
                    <div dangerouslySetInnerHTML={{ __html: content.content }} style={{ fontSize: 40 }} />
                  </>
                )
              }
            </Col>
          )}
        </Row>
        <LandingFooter />
      </Layout>
    </div>
  )
}

export default Page